import { intl, translate } from "./translation"

const columns = {
    email: [
        {
            key: 'email',
            get label() { return translate(intl.value('email'))},
        },
        {
            key: 'default',
            get label() { return translate(intl.default)},
        },
        {
            key: 'removeItem',
            label: '',
        },
    ],
    number: [
        {
            key: 'number',
            get label() { return translate(intl.phone)},
        },
        {
            key: 'mobile',
            get label() { return translate(intl.mobile)},
        },
        {
            key: 'default',
            get label() {return translate(intl.default)},
        },
        {
            key: 'removeItem',
            label: '',
        },
    ],
}

export { columns }




// WEBPACK FOOTER //
// ./components/easinsure/client-profile/client-profile-form/columns.js